import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useAuth } from '../../contexts/AuthContext';
import { getMyStores } from '../../api/stores';
import { getKnowledgeBases } from '../../api/knowledgeBases';


const SKIP_PREFIXES = ['/', '/auth', '/calendar', '/onboarding'];

const KbOnboardingModal = () => {
    const { isLoggedIn, isAuthChecking } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const [storeUuid, setStoreUuid] = useState(null);
    const checked = useRef(false);

    useEffect(() => {
        if (isAuthChecking || !isLoggedIn || checked.current) return;

        const path = location.pathname;
        const skip = SKIP_PREFIXES.some((p) =>
            p === '/' ? path === '/' : path.startsWith(p)
        );
        if (skip) return;

        checked.current = true;

        (async () => {
            try {
                const stores = await getMyStores();
                if (!stores || stores.length === 0) return;
                const uuid = stores[0].uuid;
                const kbs = await getKnowledgeBases(uuid);
                if (kbs.length === 0) {
                    setStoreUuid(uuid);
                    setVisible(true);
                }
            } catch {
                // 조용히 실패 — 모달 없이 정상 이용
            }
        })();
    }, [isLoggedIn, isAuthChecking, location.pathname]);

    if (!visible) return null;

    return (
        <Overlay onClick={() => setVisible(false)}>
            <Card onClick={(e) => e.stopPropagation()}>
                <Icon>🧠</Icon>
                <Title>보이스 에이전트를 똑똑하게 만들어보세요</Title>
                <Desc>
                    고객이 자주 묻는 질문을 등록하면<br />
                    AI가 더 정확하고 빠르게 답변할 수 있어요.
                </Desc>
                <Actions>
                    <SkipBtn onClick={() => setVisible(false)}>나중에 할게요</SkipBtn>
                    <CtaBtn onClick={() => { setVisible(false); navigate(`/stores/${storeUuid}/knowledge-bases`); }}>
                        지금 등록하기
                    </CtaBtn>
                </Actions>
            </Card>
        </Overlay>
    );
};


const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 500;
    padding: 24px;
    box-sizing: border-box;
    backdrop-filter: blur(4px);
`;

const Card = styled.div`
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 20px;
    padding: 40px 36px;
    max-width: 420px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
`;

const Icon = styled.div`
    font-size: 40px;
    line-height: 1;
`;

const Title = styled.h2`
    font-family: Pretendard;
    font-size: 18px;
    font-weight: 700;
    color: #111111;
    margin: 0;
    line-height: 1.4;
`;

const Desc = styled.p`
    font-family: Pretendard;
    font-size: 14px;
    color: #777777;
    margin: 0;
    line-height: 1.7;
`;

const Actions = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    margin-top: 8px;
`;

const SkipBtn = styled.button`
    flex: 1;
    background: none;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    padding: 12px 0;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s;
    &:hover { border-color: #bbbbbb; color: #555555; }
`;

const CtaBtn = styled.button`
    flex: 2;
    background: #487BFD;
    border: none;
    border-radius: 10px;
    padding: 12px 0;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: opacity 0.15s;
    &:hover { opacity: 0.88; }
`;


export default KbOnboardingModal;
